var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"round"},[_c('div',{staticClass:"content"},[_c('player')],1),_c('div',{staticClass:"footer"},[_c('div',[_vm._v("教室监控")]),_c('div',[_c('img',{staticStyle:{"width":"24px"},attrs:{"src":require("../assets/images/device/qp.png"),"title":"点击全屏"},on:{"click":_vm.fullScreen}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }